import { useEffect , useState } from "react";

function Timer({time_count , navigateToResult}) {
  const [timer, setTimer] = useState(0);
  const [time, setTime] = useState({
    seconds: '0',
    minutes: '0',
  });

  useEffect(() => {
    setTimer((time_count))
    timerHandler(time_count)
  }, [])

 

  useEffect(() => {
    const counterInterval = setInterval( () => {
      timerHandler(timer)
    } , 1000)
    
    return () => {
      clearInterval(counterInterval)
    }
  } , [timer])


  

  const timerHandler = (seconds_time) => {

    if(seconds_time != 0)
    {
        
    --seconds_time;
    let seconds = String(seconds_time % 60);
    let minutes = String(Math.floor(seconds_time / 60));
      
    if(seconds < 10)
    {
      seconds = '0' + seconds
    }
    if(minutes < 10)
    {
      minutes = '0' + minutes
    } 

    setTime({
      seconds,
      minutes,
    });

    setTimer(seconds_time);
    }
    else
    {
        navigateToResult()
      
    }
  };
  return (
    <span className="footer__text_time">
      {time.seconds} : {time.minutes}
    </span>
  );
}

export default Timer;
